import * as React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
// tslint:disable-next-line:no-unused-variable
import { ICrudGetAction, TextFormat } from 'react-jhipster';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './sport.reducer';
import { ISport } from 'app/shared/model/sport.model';
// tslint:disable-next-line:no-unused-variable
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface ISportDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: number }> {}

export class SportDetail extends React.Component<ISportDetailProps> {
  componentDidMount() {
    this.props.getEntity(this.props.match.params.id);
  }

  render() {
    const { sportEntity } = this.props;
    return (
      <Row>
        <Col md="8">
          <h2>
            Sport [<b>{sportEntity.id}</b>]
          </h2>
          <dl className="jh-entity-details">
            <dt>
              <span id="name">Name</span>
            </dt>
            <dd>{sportEntity.name}</dd>
            <dt>
              <span id="iconName">Icon Name</span>
            </dt>
            <dd>{sportEntity.iconName}</dd>
            <dt>
              <span id="createdDate">Created Date</span>
            </dt>
            <dd>
              <TextFormat value={sportEntity.createdDate} type="date" format={APP_DATE_FORMAT} />
            </dd>
            <dt>
              <span id="lastModifiedDate">Last Modified Date</span>
            </dt>
            <dd>
              <TextFormat value={sportEntity.lastModifiedDate} type="date" format={APP_DATE_FORMAT} />
            </dd>
            <dt>Created By</dt>
            <dd>{sportEntity.createdBy ? sportEntity.createdBy.login : ''}</dd>
            <dt>Last Modified By</dt>
            <dd>{sportEntity.lastModifiedBy ? sportEntity.lastModifiedBy.login : ''}</dd>
          </dl>
          <Button tag={Link} to="/entity/sport" replace color="info">
            <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
          </Button>&nbsp;
          <Button tag={Link} to={`/entity/sport/${sportEntity.id}/edit`} replace color="primary">
            <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
          </Button>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = ({ sport }: IRootState) => ({
  sportEntity: sport.entity
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(SportDetail);
